module.exports = __webpack_public_path__ + "img/cszl-2.a1801a87.png";